import { forwardRef, useRef, useEffect, useCallback } from 'react';
import { IconNames } from '@shipengine/giger-theme';
import { Typography } from '../Typography/Typography.js';
import { getOptionStyles, getOptionIconStyles } from './OptionStyles.js';
import { useMergeRefs } from 'use-callback-ref';
import { jsx, jsxs, Fragment } from '@emotion/react/jsx-runtime';
import { Icon } from '../Icon/Icon.js';
import { IconSize } from '../Icon/types/size.js';

const Option = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    value,
    onClick,
    onMouseEnter,
    selected = false,
    focused = false,
    showTick = true,
    hasSublabel = false,
    tabIndex = 0,
    children,
    ...rest
  } = _ref;
  const optionRef = useRef(null);
  const buttonRef = useMergeRefs([optionRef, ref]);
  const handleOnClick = event => {
    onClick === null || onClick === void 0 ? void 0 : onClick(event, value);
  };
  const mouseOverRef = useRef(false);
  useEffect(() => {
    if (focused && !mouseOverRef.current) {
      var _buttonRef$current, _buttonRef$current$sc;
      (_buttonRef$current = buttonRef.current) === null || _buttonRef$current === void 0 ? void 0 : (_buttonRef$current$sc = _buttonRef$current.scrollIntoView) === null || _buttonRef$current$sc === void 0 ? void 0 : _buttonRef$current$sc.call(_buttonRef$current, {
        block: 'nearest'
      });
    }
  }, [focused, buttonRef]);
  const hanleOnMouseEnter = useCallback(() => {
    mouseOverRef.current = true;
    onMouseEnter === null || onMouseEnter === void 0 ? void 0 : onMouseEnter(value);
  }, [onMouseEnter, value]);
  return jsx(Typography, {
    ref: buttonRef,
    component: "button",
    type: "button",
    css: getOptionStyles(selected, focused, hasSublabel),
    variant: "body2",
    bold: selected,
    role: "menuitem",
    onClick: handleOnClick,
    onMouseEnter: hanleOnMouseEnter,
    onMouseLeave: () => mouseOverRef.current = false,
    ...rest,
    children: jsxs(Fragment, {
      children: [jsx("div", {
        tabIndex: tabIndex,
        children: children
      }), selected && showTick && jsx(Icon, {
        css: getOptionIconStyles,
        name: IconNames.CHECK_MARK,
        size: IconSize.SIZE_MEDIUM
      })]
    })
  });
});
Option.displayName = 'Option';

export { Option };
//# sourceMappingURL=Option.js.map
